<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>
        <v-col>
          <v-row class="primary--text pb-6">Resumo do Crédito</v-row>
          <v-card id="fluxoirregular-timeline" class="pa-4 pl-8">
            <div class="d-flex" v-for="(item, i) in detalhamento" :key="i">
              <v-divider v-if="i < detalhamento.length - 1" vertical />
              <v-img :src="item.icon" max-width="18" max-height="18" />
              <div class="d-flex flex-column mb-3 px-4 text-left">
                <span class="text--secondary">
                  {{ item.title }}
                </span>
                <span class="text-subtitle-1">
                  {{ item.body }}
                </span>
                <span class="text-caption">
                  {{ item.footer }}
                </span>
              </div>
            </div>
            <div class="mb-4">
              <span class="text-caption mb-2 text--secondary" bold>
                Custo efetivo total (CET)
              </span>
              <span class="text-subtitle-1">
                {{ $api.UI.Format.Decimal(model.PercCETMensal) }}% a.m. /
                {{ $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.
              </span>
            </div>
            <div class="mb-4">
              <span class="text-caption mb-2 text--secondary" bold>
                Forma de pagamento
              </span>
              <span class="text-subtitle-1">
                {{ model.QtdeParcelas }}
                {{ model.QtdeParcelas === 1 ? "parcela" : "parcelas" }} de R$
                {{ $api.UI.Format.Decimal(model.VlrParcelaCalculado) }}
              </span>
            </div>
            <div>
              <span class="text-caption mb-2 text--secondary" bold>
                Data do primeiro vencimento
              </span>
              <span class="text-subtitle-1">
                {{
                  $api.UI.Format.Date(
                    model.DtPrimeiroVencto,
                    "dd 'de' MMMM 'de' yyyy"
                  )
                }}
              </span>
            </div>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    modal: { type: Boolean, default: false },
    model: { type: Object }
  },
  data () {
    return {
      isLoaded: false,
    };
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
  },
  computed: {
    detalhamento () {
      if (!this.model) { return [] }
      return [
        {
          icon: require('assets/icons/timeline-circle.svg'),
          title: 'Valor Desejado',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrSolicitado)}`
        },
        {
          icon: require('assets/icons/timeline-plus.svg'),
          title: 'Valor do IOF',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrIOF)}`
        },
        {
          icon: require('assets/icons/timeline-plus.svg'),
          title: 'Valor da TAC',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrTAC)}`
        },
        {
          icon: require('assets/icons/timeline-equals.svg'),
          title: 'Valor Financiado',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrTotalCredito)}`,
        },
        {
          icon: require('assets/icons/timeline-plus.svg'),
          title: 'Valor do Juros',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrTotalDivida - this.model.VlrTotalCredito)}`,
          footer: `${this.$api.UI.Format.Decimal(this.model.PercJurosMensal)}% a.m. / ${this.$api.UI.Format.Decimal(this.model.PercJurosAnual)}% a.a.`,
        },
        {
          icon: require('assets/icons/timeline-equals.svg'),
          title: 'Valor total a pagar',
          body: `R$ ${this.$api.UI.Format.Decimal(this.model.VlrTotalDivida)}`,
        },
      ]
    }
  }
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
